import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';

const BulkMarkCompleteReferralsModal = ({ isOpen, onClose, onConfirm, referrals, loading }) => {
  if (!isOpen || !referrals || referrals.length === 0) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container modal-animated">
        <div className="modal-header">
          <h2>Mark Referrals Complete</h2>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          <p>Are you sure you want to mark {referrals.length} referral{referrals.length > 1 ? 's' : ''} as complete?</p>
          <div className="bulk-document-list">
            {referrals.slice(0, 5).map(r => (
              <div key={r.referralId} className="bulk-document-item">
                <div className="bulk-document-name">{r.patient?.name || 'Unknown Patient'}</div>
                <div className="bulk-document-assignee">{r.text || 'No notes'}</div>
              </div>
            ))}
            {referrals.length > 5 && (
              <div className="bulk-document-more">
                ... and {referrals.length - 5} more referral{referrals.length - 5 > 1 ? 's' : ''}
              </div>
            )}
          </div>
          <p style={{ marginTop: '15px', color: '#666', fontSize: '14px' }}>
            All selected referrals will be marked as complete.
          </p>
        </div>
        <div className="modal-actions">
          <button className="cancel-button" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="admin-submit-button" onClick={onConfirm} disabled={loading}>
            {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Mark All Complete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkMarkCompleteReferralsModal;
